import { render, staticRenderFns } from "./MainLedgerZaPovezati.vue?vue&type=template&id=ddc3d9fa&scoped=true"
import script from "./MainLedgerZaPovezati.vue?vue&type=script&lang=js"
export * from "./MainLedgerZaPovezati.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerZaPovezati.vue?vue&type=style&index=0&id=ddc3d9fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc3d9fa",
  null
  
)

export default component.exports